<!--
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：默认页面显示区域
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
-->
<template>
	<div id="app-index" class="app-index">
	<!-- <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"> -->
    <header>
        <div class="container header-content">
            <div class="logo">
                <i class="fas fa-code"></i>
                <span>API文档中心</span>
            </div>
            <nav>
                <ul>
                    <router-link to="/OverView">
						<li><i class="fas fa-home"></i> 概述</li>
					</router-link>
                    <router-link to="/QuickStart">
						<li><i class="fas fa-rocket"></i> 快速开始</li>
					</router-link>
                    <router-link to="/EndPoints">
						<li><i class="fas fa-plug"></i> 接口端点</li>
					</router-link>
                    <router-link to="/Examples">
						<li><i class="fas fa-code"></i> 示例</li>
					</router-link>
                    <router-link to="/Support">
						<li><i class="fas fa-question-circle"></i> 支持</li>
					</router-link>
                </ul>
            </nav>
        </div>
    </header>
    <div class="container">
        <section class="hero">
            <h1>API 接口说明文档</h1>
            <p>欢迎使用我们的API服务。本文档提供了完整的接口参考、示例代码和最佳实践指南，帮助您快速集成我们的服务到您的应用中。</p>
            
            <div class="status-bar">
                <div class="status-indicator">
                    <div class="status-dot"></div>
                    <span>所有系统运行正常</span>
                </div>
                <div class="version-info">当前版本: v2.1.0 | 最后更新: 2024年10月15日</div>
            </div>
            
            <div class="cta-buttons">
                <a href="#quickstart" class="btn btn-primary">
                    <i class="fas fa-play-circle"></i> 快速开始
                </a>
                <a href="#endpoints" class="btn btn-outline">
                    <i class="fas fa-list"></i> 查看接口列表
                </a>
            </div>
        </section>

        <section id="features">
            <h2>主要特性</h2>
            <div class="features">
                <div class="feature-card">
                    <div class="feature-icon">
                        <i class="fas fa-exchange-alt"></i>
                    </div>
                    <h3>RESTful 设计</h3>
                    <p>基于REST架构风格，提供统一规范的资源操作接口，易于集成和使用。</p>
                </div>
                <div class="feature-card">
                    <div class="feature-icon">
                        <i class="fas fa-file-code"></i>
                    </div>
                    <h3>JSON 格式</h3>
                    <p>所有请求和响应都使用JSON格式，支持跨平台和跨语言调用。</p>
                </div>
                <div class="feature-card">
                    <div class="feature-icon">
                        <i class="fas fa-lock"></i>
                    </div>
                    <h3>OAuth 2.0 认证</h3>
                    <p>采用标准的OAuth 2.0协议进行身份验证和授权，保障接口安全。</p>
                </div>
                <div class="feature-card">
                    <div class="feature-icon">
                        <i class="fas fa-tachometer-alt"></i>
                    </div>
                    <h3>速率限制</h3>
                    <p>合理的API调用频率限制，保证服务的稳定性和公平使用。</p>
                </div>
                <div class="feature-card">
                    <div class="feature-icon">
                        <i class="fas fa-bug"></i>
                    </div>
                    <h3>详细错误代码</h3>
                    <p>提供清晰的错误代码和描述，帮助快速定位和解决问题。</p>
                </div>
                <div class="feature-card">
                    <div class="feature-icon">
                        <i class="fas fa-bell"></i>
                    </div>
                    <h3>Webhook 支持</h3>
                    <p>支持Webhook机制，实时接收事件通知，无需轮询查询。</p>
                </div>
            </div>
        </section>

        <section class="code-samples">
            <h2>代码示例</h2>
            <div class="code-tabs">
                <div class="code-tab active" onclick="switchTab('curl')">
                    <i class="fas fa-terminal"></i> cURL
                </div>
                <div class="code-tab" onclick="switchTab('python')">
                    <i class="fab fa-python"></i> Python
                </div>
                <div class="code-tab" onclick="switchTab('javascript')">
                    <i class="fab fa-js"></i> JavaScript
                </div>
                <div class="code-tab" onclick="switchTab('php')">
                    <i class="fab fa-php"></i> PHP
                </div>
            </div>
            <div class="code-content">
                <pre id="curl-code" class="code-example">curl -X GET \
  https://api.example.com/v1/users \
  -H 'Authorization: Bearer YOUR_ACCESS_TOKEN' \
  -H 'Content-Type: application/json'</pre>
                
                <pre id="python-code" class="code-example" style="display: none;">import requests

url = "https://api.example.com/v1/users"
headers = {
    "Authorization": "Bearer YOUR_ACCESS_TOKEN",
    "Content-Type": "application/json"
}

response = requests.get(url, headers=headers)
print(response.json())</pre>
                
                <pre id="javascript-code" class="code-example" style="display: none;">fetch('https://api.example.com/v1/users', {
    method: 'GET',
    headers: {
        'Authorization': 'Bearer YOUR_ACCESS_TOKEN',
        'Content-Type': 'application/json'
    }
})
.then(response => response.json())
.then(data => console.log(data))
.catch(error => console.error('Error:', error));</pre>
                
                <pre id="php-code" class="code-example" style="display: none;">$url = 'https://api.example.com/v1/users';
$headers = [
    'Authorization: Bearer YOUR_ACCESS_TOKEN',
    'Content-Type: application/json'
];

$ch = curl_init();
curl_setopt($ch, CURLOPT_URL, $url);
curl_setopt($ch, CURLOPT_HTTPHEADER, $headers);
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);

$response = curl_exec($ch);
curl_close($ch);

echo $response;</pre>
            </div>
        </section>
    </div>

    <footer>
        <div class="container footer-content">
            <div class="copyright">© 2024 API文档中心. 保留所有权利.</div>
            <div class="footer-links">
                <a href="#"><i class="fas fa-shield-alt"></i> 隐私政策</a>
                <a href="#"><i class="fas fa-file-contract"></i> 服务条款</a>
                <a href="#"><i class="fas fa-envelope"></i> 联系我们</a>
            </div>
        </div>
    </footer>
	</div>
</template>

<script>
import { getAccessCode } from '../api/'

// 输出元素
export default {
	name: 'app-index',
	data() {
		return {}
	},
	mounted() {
		}, 
	components: {
	},
	methods: {
		switchTab(lang) {
			// 隐藏所有代码示例
			document.querySelectorAll('.code-example').forEach(el => {
				el.style.display = 'none';
			});
			
			// 移除所有标签的active类
			document.querySelectorAll('.code-tab').forEach(tab => {
				tab.classList.remove('active');
			});
			
			// 显示选中的代码示例
			document.getElementById(lang + '-code').style.display = 'block';
			
			// 为当前标签添加active类
			event.currentTarget.classList.add('active');
		}
	}
}   
</script>

<style lang="less" Scoped>
.app-index {
	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 20px;
	}

	header {
		background-color: var(--light-gray);
		border-bottom: 1px solid var(--medium-gray);
		padding: 1.2rem 0;
		box-shadow: 0 2px 10px rgba(0,0,0,0.05);
	}

	.header-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.logo {
		display: flex;
		align-items: center;
		gap: 10px;
		font-size: 1.6rem;
		font-weight: bold;
		color: var(--secondary-color);
	}

	.logo i {
		color: var(--primary-color);
	}

	nav ul {
		display: flex;
		list-style: none;
		gap: 1.8rem;
	}

	nav ul li a {
		color: var(--dark-gray);
		text-decoration: none;
		font-weight: 500;
		transition: color 0.3s;
		font-size: 1rem;
	}

	nav ul li a:hover {
		color: var(--primary-color);
	}

	.hero {
		text-align: center;
		padding: 3.5rem 0;
		background: linear-gradient(to bottom, var(--light-gray), #f9f9f9);
		border-radius: 0 0 10px 10px;
	}

	.hero h1 {
		font-size: 2.6rem;
		margin-bottom: 1.2rem;
		color: var(--secondary-color);
	}

	.hero p {
		font-size: 1.2rem;
		max-width: 800px;
		margin: 0 auto 2.2rem;
		color: var(--dark-gray);
	}

	.status-bar {
		background-color: white;
		padding: 1.2rem;
		border-radius: 8px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 0 auto 2.5rem;
		box-shadow: 0 2px 8px rgba(0,0,0,0.08);
		max-width: 800px;
		border: 1px solid var(--medium-gray);
	}

	.status-indicator {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.status-dot {
		width: 12px;
		height: 12px;
		border-radius: 50%;
		background-color: var(--success-color);
	}

	.version-info {
		color: var(--dark-gray);
		font-size: 0.95rem;
	}

	.cta-buttons {
		display: flex;
		justify-content: center;
		gap: 1.2rem;
		margin: 2.5rem 0;
	}

	.btn {
		padding: 0.9rem 1.8rem;
		border-radius: 6px;
		font-weight: 600;
		text-decoration: none;
		transition: all 0.3s;
		display: inline-flex;
		align-items: center;
		gap: 8px;
	}

	.btn-primary {
		background-color: var(--primary-color);
		color: white;
		box-shadow: 0 4px 6px rgba(52, 152, 219, 0.2);
	}

	.btn-primary:hover {
		background-color: #2980b9;
		transform: translateY(-2px);
	}

	.btn-outline {
		border: 2px solid var(--primary-color);
		color: var(--primary-color);
	}

	.btn-outline:hover {
		background-color: var(--primary-color);
		color: white;
		transform: translateY(-2px);
	}

	section {
		padding: 3.5rem 0;
	}

	section h2 {
		text-align: center;
		margin-bottom: 2.5rem;
		color: var(--secondary-color);
		font-size: 2.2rem;
	}

	.features {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
		gap: 2rem;
		margin: 3rem 0;
	}

	.feature-card {
		background: white;
		padding: 2rem;
		border-radius: 10px;
		box-shadow: 0 5px 15px rgba(0,0,0,0.08);
		transition: transform 0.3s, box-shadow 0.3s;
		border: 1px solid var(--medium-gray);
		text-align: center;
	}

	.feature-card:hover {
		transform: translateY(-5px);
		box-shadow: 0 8px 20px rgba(0,0,0,0.12);
	}

	.feature-icon {
		font-size: 2.5rem;
		color: var(--primary-color);
		margin-bottom: 1.2rem;
	}

	.feature-card h3 {
		color: var(--secondary-color);
		margin-bottom: 1rem;
		font-size: 1.4rem;
	}

	.code-samples {
		background: white;
		padding: 2.5rem;
		border-radius: 10px;
		margin: 3.5rem 0;
		box-shadow: 0 5px 15px rgba(0,0,0,0.08);
		border: 1px solid var(--medium-gray);
	}

	.code-tabs {
		display: flex;
		border-bottom: 1px solid var(--medium-gray);
		margin-bottom: 1.5rem;
	}

	.code-tab {
		padding: 0.8rem 1.5rem;
		cursor: pointer;
		opacity: 0.7;
		color: var(--dark-gray);
		font-weight: 500;
		border-bottom: 2px solid transparent;
		transition: all 0.3s;
	}

	.code-tab.active {
		opacity: 1;
		color: var(--primary-color);
		border-bottom: 2px solid var(--primary-color);
	}

	.code-content {
		background: #f8f9fa;
		padding: 1.5rem;
		border-radius: 8px;
		overflow-x: auto;
		border: 1px solid var(--medium-gray);
	}

	pre {
		margin: 0;
		font-family: 'Fira Code', monospace;
		font-size: 0.95rem;
		line-height: 1.5;
	}

	footer {
		background-color: var(--light-gray);
		padding: 3rem 0;
		margin-top: 3rem;
		border-top: 1px solid var(--medium-gray);
	}

	.footer-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.footer-links {
		display: flex;
		gap: 1.5rem;
	}

	.footer-links a {
		color: var(--dark-gray);
		text-decoration: none;
		transition: color 0.3s;
	}

	.footer-links a:hover {
		color: var(--primary-color);
	}

	.copyright {
		color: var(--dark-gray);
	}

	@media (max-width: 768px) {
		.header-content {
			flex-direction: column;
			text-align: center;
			gap: 1rem;
		}
		
		nav ul {
			flex-wrap: wrap;
			justify-content: center;
			gap: 1rem;
		}
		
		.features {
			grid-template-columns: 1fr;
		}
		
		.footer-content {
			flex-direction: column;
			gap: 1.5rem;
			text-align: center;
		}
		
		.status-bar {
			flex-direction: column;
			gap: 1rem;
			text-align: center;
		}
		
		.cta-buttons {
			flex-direction: column;
			align-items: center;
		}
	}
}
</style>